import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteHeader } from '@/components/generals/site-header'
import { SiteFooter } from '@/components/generals/site-footer'
import { MobileActionBar } from '@/components/generals/mobile-action-bar'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#konten'
                className='sr-only z-50 rounded-full bg-white px-4 py-2 font-semibold text-ink shadow-lg focus:not-sr-only focus:fixed focus:top-3 focus:left-3'
            >
                Lewati ke konten utama
            </a>

            <SiteHeader />

            <main id='konten' className='flex-1'>
                {children}
            </main>

            <SiteFooter />
            <MobileActionBar />
        </div>
    )
}
